export default __webpack_public_path__ + "static/default-7c6cb37c95e4cef2e340ef8fc63113a2.png";